/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { Button, Form, Modal, Radio, Row, Space } from 'antd';

import CustomRadioButton from '../CustomRadioButton/CustomRadioButton';
import { ReactComponent as Next } from './img/next-icon.svg';
import './style.scss';

const ModalOnboarding = ({
  userId,
  openStart,
  handleClose,
  onboardingForms,
}) => {
  const { t } = useTranslation('');
  const [form] = Form.useForm();
  const history = useHistory();

  useEffect(() => {
    if (onboardingForms?.length) {
      form.setFieldValue('formId', onboardingForms[0]?.id);
    }
  }, []);

  // const handleCreate = () => {
  //   if(onboardingForms?.length) {
  //     const formId = onboardingForms[0]?.id;
  //     history.push(`/onboarding/edit/new?account-id=${userId}&form-id=${formId}`);
  //   }
  // };
  const onSubmit = () => {
    const value = form.getFieldsValue(true);
    console.log('🚀 ~ onSubmit ~ value:', value);
    if (value?.formId) {
      history.push(
        `/onboarding/edit/new?account-id=${userId}&form-id=${value.formId}`,
      );
      handleClose();
    }
  };

  return (
    <Modal
      width={700}
      className="onboarding-start-modal"
      centered
      open={openStart}
      onCancel={handleClose}
      footer={false}
      zIndex={1500}
      closable={false}
      onFinish={onSubmit}
    >
      <div className="">
        <h1 className="onboarding-start-title">{t('ADVICE')}</h1>
        <p className="onboarding-start-description">{t('SELECT_ADVICE')}</p>
        <div className="options-wrapper">
          <h2 className="options-title">{t('OPTIONS')}*</h2>
          <Form
            form={form}
            name="filter-config"
            layout="vertical"
            onFinish={onSubmit}
          >
            <Form.Item name="formId" className="">
              <Radio.Group className="options-radio-group">
                <Space direction="vertical">
                  {onboardingForms?.map((form) => (
                    <CustomRadioButton key={form.id} value={form.id}>
                      <span className="onboarding-form-name">{form.name}</span>
                    </CustomRadioButton>
                  ))}
                </Space>
              </Radio.Group>
            </Form.Item>
          </Form>
        </div>
      </div>
      <Row justify={'center'} className="onboarding-start-btn-wrapper">
        <Button
          className="onboarding-start-submit"
          icon={<Next />}
          iconPosition="end"
          onClick={() => form.submit()}
        >
          {t('CONTINUE')}
        </Button>
      </Row>
    </Modal>
  );
};

export default ModalOnboarding;

ModalOnboarding.propTypes = {
  userId: PropTypes.string,
  openStart: PropTypes.bool,
  handleClose: PropTypes.func,
  onboardingForms: PropTypes.array,
};
